import * as React from "react";
import { uuid } from "@utdanningsdirektoratet/utils/useId";
import { Portal } from "react-portal";
import { create } from "zustand";
import Notification from "./Notification";
import { NotificationItem } from "./types";

const store = create<{ notifications: Array<InternalNotificationItem> }>(
  () => ({
    notifications: [],
  }),
);

interface InternalNotificationItem extends NotificationItem {
  id: string;
}

export const newNotification = (
  type: "success" | "info" | "error",
  title: string,
  message?: React.ReactNode,
  closeOnClick?: boolean,
  autoClose?: boolean,
): void => {
  store.setState((state) => ({
    notifications: [
      ...state.notifications,
      {
        id: uuid(),
        type,
        title,
        message,
        closeOnClick,
        autoClose,
      },
    ],
  }));
};

export const clearNotifications = (): void => {
  store.setState({ notifications: [] });
};

type NotificationsProps = {
  notifications?: Array<NotificationItem>;
  closeOnClick?: boolean;
};

const Notifactions: React.FC<NotificationsProps> = ({
  closeOnClick,
  notifications = [],
}) => {
  const _notifications = store((state) => state.notifications);

  React.useEffect(() => {
    store.setState({
      notifications: notifications.map(
        (n) => ({ ...n, id: uuid() }) as InternalNotificationItem,
      ),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeNotification = (id: string): void => {
    store.setState((prevState) => ({
      notifications: prevState.notifications.filter(
        (n: InternalNotificationItem) => n.id !== id,
      ),
    }));
  };

  return (
    <Portal node={document && document.getElementById("app")}>
      {_notifications.map((notification) => {
        return (
          <Notification
            key={notification.id}
            id={notification.id}
            title={notification.title}
            message={notification.message}
            type={notification.type}
            onClose={() => removeNotification(notification.id)}
            closeOnClick={notification.closeOnClick || closeOnClick}
          />
        );
      })}
    </Portal>
  );
};

export default Notifactions;
